import React from 'react';

const WebsiteMoodboardModal = ({
    isOpen,
    onClose,
    isLoading,
    html,
    error
}) => {
    if (!isOpen) {
        return null;
    }

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(7, 7, 10, 0.92)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 10000,
                padding: '24px'
            }}
            onClick={onClose}
        >
            <div
                style={{
                    position: 'relative',
                    width: '100%',
                    maxWidth: '1280px',
                    height: '100%',
                    maxHeight: '860px',
                    backgroundColor: '#ffffff',
                    borderRadius: '12px',
                    boxShadow: '0 18px 60px rgba(0, 0, 0, 0.35)',
                    border: '1px solid rgba(148, 163, 184, 0.4)',
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column'
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    onClick={onClose}
                    style={{
                        position: 'absolute',
                        top: '14px',
                        right: '14px',
                        backgroundColor: '#ef4444',
                        color: '#ffffff',
                        border: 'none',
                        borderRadius: '999px',
                        width: '40px',
                        height: '40px',
                        fontSize: '22px',
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontWeight: 'bold',
                        boxShadow: '0 8px 20px rgba(239, 68, 68, 0.35)',
                        transition: 'transform 0.2s ease, background-color 0.2s ease',
                        zIndex: 1
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.backgroundColor = '#dc2626';
                        e.target.style.transform = 'scale(1.05)';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.backgroundColor = '#ef4444';
                        e.target.style.transform = 'scale(1)';
                    }}
                >
                    ×
                </button>

                <div
                    style={{
                        padding: '20px 24px 12px 24px',
                        borderBottom: '1px solid rgba(226, 232, 240, 0.8)',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        backgroundColor: '#f9fafb'
                    }}
                >
                    <div>
                        <h3
                            style={{
                                margin: 0,
                                fontSize: '18px',
                                fontWeight: 600,
                                color: '#0f172a'
                            }}
                        >
                            Website Moodboard
                        </h3>
                        <p
                            style={{
                                margin: '4px 0 0 0',
                                fontSize: '13px',
                                color: '#6b7280'
                            }}
                        >
                            Visual overview of this website&apos;s look &amp; feel.
                        </p>
                    </div>
                </div>

                <div
                    style={{
                        flex: 1,
                        backgroundColor: '#f3f4f6',
                        padding: '16px'
                    }}
                >
                    {isLoading && (
                        <div
                            style={{
                                height: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: '#4b5563',
                                fontSize: '14px',
                                fontWeight: 500
                            }}
                        >
                            Loading moodboard…
                        </div>
                    )}

                    {!isLoading && error && (
                        <div
                            style={{
                                maxWidth: '480px',
                                margin: '40px auto',
                                padding: '16px 18px',
                                borderRadius: '8px',
                                backgroundColor: '#fef2f2',
                                border: '1px solid #fecaca',
                                color: '#b91c1c',
                                fontSize: '13px'
                            }}
                        >
                            {error}
                        </div>
                    )}

                    {!isLoading && !error && html && (
                        <iframe
                            title="Website moodboard"
                            srcDoc={html}
                            sandbox="allow-scripts allow-same-origin allow-popups"
                            style={{
                                width: '100%',
                                height: '100%',
                                border: 'none',
                                borderRadius: '10px',
                                backgroundColor: '#ffffff',
                                boxShadow: '0 10px 30px rgba(15, 23, 42, 0.12)'
                            }}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default WebsiteMoodboardModal;



